var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('div',{staticClass:"container"},[_c('div',{},[_c('h1',[_vm._v("404")]),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('page_not_found')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }